import { render } from "./TheChangeInforSelect.vue?vue&type=template&id=fb53153a"
import script from "./TheChangeInforSelect.vue?vue&type=script&lang=js"
export * from "./TheChangeInforSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__